// Headline KPIs — sourced from YES Foundation Annual Reports
// FY24-25 figures with FY23-24 used for YoY deltas.

export const HEADLINE_KPIS = {
  fy: "FY 2024-25",
  beneficiaries: { value: 25400, prev: 17600, label: "Lives impacted", unit: "" },
  states:        { value: 18,    prev: 15,    label: "States reached" },
  districts:     { value: 72,    prev: 65,    label: "Districts reached" },
  partners:      { value: 24,    prev: 19,    label: "Implementation partners" },
  programSpendCr:{ value: 26.46, prev: 22.10, label: "Program spend",     unit: "₹ Cr" },
  econPotentialCr:{value: 100.0, prev: 80.0,  label: "Economic potential unlocked", unit: "₹ Cr" },
  treesPlanted: { value: 450000, prev: 200000, label: "Trees planted (FY)" },
  co2Tonnes:    { value: 380000, prev: 170000, label: "CO₂ sequestered (20-yr)", unit: "t" },
};

// Per-pillar KPIs
export const PILLAR_KPIS = {
  employability: [
    { key: "youthSkilled",   value: 7200, label: "Youth skilled",            icon: "GraduationCap" },
    { key: "placementRate",  value: 70,   label: "Placement rate",  unit:"%", icon: "Briefcase" },
    { key: "womenPct",       value: 32,   label: "Women in cohort", unit:"%", icon: "User" },
    { key: "econUnlockedCr", value: 40,   label: "Economic potential", unit:"₹ Cr", icon: "TrendingUp" },
  ],
  entrepreneurship: [
    { key: "incomeEnhanced", value: 18300, label: "Farmers / women / artisans", icon: "Users" },
    { key: "villagesReached",value: 1240,  label: "Villages reached",            icon: "MapPin" },
    { key: "hectaresTreated",value: 720,   label: "Hectares treated",            icon: "Sprout" },
    { key: "econUnlockedCr", value: 50,    label: "Economic potential", unit:"₹ Cr", icon: "TrendingUp" },
  ],
  environment: [
    { key: "treesPlanted",   value: 450000, label: "Trees planted (FY)",   icon: "TreePine" },
    { key: "co2Tonnes",      value: 380000, label: "CO₂ sequestered (t)",  icon: "Leaf" },
    { key: "msmeReached",    value: 520,    label: "MSMEs supported",      icon: "Factory" },
    { key: "kwhSaved",       value: 142000, label: "kWh saved annually",   icon: "Zap" },
  ],
};
